import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  Background,
  Container,
  Close,
  Header,
  Form,
  DropDiv2,
  ImageContainer,
  InputFileManual,
  PreviewImage,
  RetunrIcon,
} from "./style";
import Input from "../../Input";
import InputSelect from "../../Select";
import Icone from "../../../utils/Icone";
import Button from "../../Button";
import api from "../../../Services/api";
import UserDefault from "../../../assets/images/user.png";
import { UpdateImageApi } from "../../../Services/sendImage.";
import { format, parseISO } from "date-fns";
import { Alert } from "../../../utils/Alert";
import Url_Image from "../../../assets/URL'S/Url_Image";

const EditAluno = ({ Show, setShow, editAluno, setEditAluno, setReload }) => {
  if (!Show) return;
  const modalRef = useRef();
  const [formData, setFormData] = useState({
    imageAluno: "",
    novaImageAluno: "",
    rm: "",
    nome: "",
    email: "",
    curso: null,
    convenio: "",
    dataNascimento: "",
    dataInicio: "",
    dataFim: "",
    FileManual: null,
  });

  const [optionsCurso, setOptionsCurso] = useState([]);
  const [optionsConvenio, setOptionsConvenio] = useState([]);

  const updateFormData = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    if (!Show || !editAluno?.rm) return;

    async function fetchImage() {
      const imgBase64 = await Url_Image(editAluno.rm);
      setFormData((prev) => ({
        ...prev,
        imageAluno: imgBase64,
      }));
    }

    fetchImage();
  }, [Show, editAluno]);

  useEffect(() => {
    if (!Show) return;
    if (editAluno) {
      const initialCourse = { label: editAluno.nome_curso, value: editAluno.id_curso };
      const initialConvenio = { label: editAluno.convenio, value: editAluno.convenio };
      api
        .get("/curso/listar?procurar")
        .then((res) => {
          const data = res.data;
          const resultsCurso = [];
          data.forEach((value) => {
            resultsCurso.push({
              label: value.nome,
              value: value.id,
            });
          });
          setOptionsCurso(
            [
              initialCourse,
              ...resultsCurso
                .filter((item) => item.label !== editAluno.nome_curso)
                .map((item) => ({ label: item.label, value: item.value })),
            ].sort((a, b) => a.label.localeCompare(b.label)) // Ordenação alfabética
          );
        })
        .catch((err) => {
          console.log(err);
          Alert({ tipo: "Erro", mensagem: "Erro ao carregar os dados." });
        });

      setOptionsConvenio([initialConvenio]);
      setFormData((prev) => ({
        ...prev,
        rm: editAluno?.rm,
        nome: editAluno?.nome_aluno,
        email: editAluno?.email,
        curso: editAluno.id_curso,
        convenio: editAluno.convenio,
        dataNascimento: editAluno?.dt_nascimento ? format(parseISO(editAluno.dt_nascimento), "yyyy-MM-dd") : "",
        dataInicio: editAluno?.dt_inicio ? format(parseISO(editAluno.dt_inicio), "yyyy-MM-dd") : "",
        dataFim: editAluno?.dt_termino ? format(parseISO(editAluno.dt_termino), "yyyy-MM-dd") : "",
        FileManual: null,
      }));
    }
  }, [editAluno, Show]);

  useEffect(() => {
    if (!Show) return;
    if (formData.curso) {
      api
        .get(`/curso/listar-convenios?procurar=${formData.curso}`)
        .then((res) => {
          setOptionsConvenio(
            res.data.map((value) => ({
              label: value.convenio,
              value: value.convenio,
            }))
          );
        })
        .catch((err) => console.error(err));
    }
  }, [formData.curso, Show]);

  const handleFileChange = useCallback((e) => {
    const file = e.target.files[0];
    if (
      file?.type.includes("image") ||
      file?.type.includes("png") ||
      file?.type.includes("jpeg") ||
      file?.type.includes("jpg")
    ) {
      updateFormData("FileManual", file);
      updateFormData("novaImageAluno", URL.createObjectURL(file));
    } else {
      Alert({ tipo: "Alert2", mensagem: "Formato não permitido!" });
    }
  }, []);

  const resetForm = useCallback(() => {
    setFormData({
      imageAluno: "",
      novaImageAluno: "",
      rm: "",
      nome: "",
      email: "",
      curso: "",
      convenio: "",
      dataNascimento: "",
      dataInicio: "",
      dataFim: "",
      FileManual: null,
    });
  }, []);

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (formData.FileManual) {
        UpdateImageApi(editAluno?.rm, formData.FileManual);
      }
      const data = {
        id_aluno: editAluno?.id,
        rm: editAluno?.rm,
        nome: formData.nome || editAluno?.nome_aluno,
        email: formData.email || editAluno?.email,
        dt_nascimento: formData.dataNascimento || format(parseISO(editAluno?.dt_nascimento), "yyyy-MM-dd"),
        dt_inicio: formData.dataInicio || format(parseISO(editAluno?.dt_inicio), "yyyy-MM-dd"),
        dt_termino: formData.dataFim || format(parseISO(editAluno?.dt_termino), "yyyy-MM-dd"),
        id_curso: formData.curso || editAluno?.id_curso,
      };
      const validationChecks = [
        { condition: !data.id_curso, message: "Escolha um curso" },
        { condition: !data.nome, message: "Insira o nome do aluno corretamente." },
        { condition: !data.email, message: "Insira o E-mail do aluno corretamente." },
        { condition: !data.dt_nascimento, message: "Insira a data de nascimento corretamente." },
        { condition: !data.dt_inicio, message: "Insira a data de inicio corretamente." },
        { condition: !data.dt_termino, message: "Insira a data de termino corretamente." },
      ];
      for (const check of validationChecks) {
        if (check.condition) {
          Alert({ tipo: "Alert2", mensagem: check.message });
          return;
        }
      }
      try {
        const response = await api.patch("/aluno/atualizar", data);
        await Alert({
          tipo: "Sucesso2",
          mensagem: response.data.mensagem.split(".")[0] || "Dados atualizados com sucesso",
        });
        setReload(true);
        setShow(false);
      } catch (err) {
        Alert({
          tipo: "Erro",
          mensagem: err.response?.data?.erro.split(".")[0] || "Falha ao atualizar os dados Aluno.",
        });
        console.error(err);
      }
    },
    [formData, editAluno]
  );

  return (
    <Background
      Show={Show}
      ref={modalRef}
      onClick={(e) => {
        if (modalRef.current === e.target) {
          resetForm();
          setEditAluno("");
          setShow(false);
        }
      }}
    >
      <Container>
        <Close>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              resetForm();
              setEditAluno("");
              setShow(false);
            }}
          >
            <Icone name={"X"} color={" var(--azul)"} size={36} />
          </div>
        </Close>
        <Header>Edição</Header>
        <Form onSubmit={handleSubmit}>
          <DropDiv2>
            <ImageContainer>
              <InputFileManual placeholder="FOTO" type="file" accept="image/*" onChange={handleFileChange} />
              <label htmlFor="">
                <PreviewImage
                  src={formData.FileManual ? formData.novaImageAluno : formData.imageAluno}
                  alt={formData.rm}
                />
              </label>
              {formData.FileManual && (
                <RetunrIcon
                  title="Voltar Imagem padrão"
                  onClick={() => {
                    updateFormData("FileManual", null);
                    updateFormData("imageAluno", formData.imageAluno ?? UserDefault);
                  }}
                />
              )}
            </ImageContainer>
          </DropDiv2>
          <Input placeholder="RM" placeholdercolor="var(--azul)" disabled={true} value={formData.rm} />
          <Input
            placeholder="Nome"
            placeholdercolor="var(--azul)"
            value={formData.nome}
            event={(e) => updateFormData("nome", e.target.value)}
          />
          <Input
            placeholder="E-mail"
            placeholdercolor="var(--azul)"
            value={formData.email}
            event={(e) => updateFormData("email", e.target.value)}
          />
          <Input
            type="date"
            color="var(--azul)"
            placeholder="Nascimento"
            placeholdercolor="var(--azul)"
            value={formData.dataNascimento}
            event={(e) => updateFormData("dataNascimento", e.target.value)}
          />
          <div style={{ display: "flex", gap: "1rem" }}>
            <Input
              type="date"
              color="var(--azul)"
              placeholder="Inicio"
              placeholdercolor="var(--azul)"
              value={formData.dataInicio}
              event={(e) => updateFormData("dataInicio", e.target.value)}
            />
            <Input
              type="date"
              color="var(--azul)"
              placeholder="Fim"
              placeholdercolor="var(--azul)"
              value={formData.dataFim}
              event={(e) => updateFormData("dataFim", e.target.value)}
            />
          </div>
          <InputSelect
            Label={`Curso`}
            Style1={{ color: "var(--azul)" }}
            Style2={{ color: "white" }}
            Style3={{ color: "white" }}
            Options={optionsCurso}
            Default={formData.curso || editAluno.id_curso}
            value={formData.curso || editAluno.id_curso}
            OnChange={(e) => updateFormData("curso", e.target.value)}
          />
          <InputSelect
            Style1={{ color: "var(--azul)" }}
            Style2={{ color: "white", marginBottom: "0.5rem" }}
            Style3={{ color: "white" }}
            color="var(--azul)"
            placeholdercolor="var(--azul)"
            Label={"Convênio"}
            Options={optionsConvenio}
            Default={formData.convenio || editAluno.convenio}
            value={formData.convenio || editAluno.convenio}
            OnChange={(e) => updateFormData("convenio", e.target.value)}
          />
          <Button width="100%" height="100%" placeholder="Atualizar" event={handleSubmit} />
        </Form>
      </Container>
    </Background>
  );
};

export default EditAluno;
